var _mask, _rect, _mask2, _rect2, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceAutomation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_44981_9412",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 25,
    height: 25,
    rx: 0.833333
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 25,
    height: 25,
    rx: 0.833333,
    stroke: "#2E2E2E",
    strokeWidth: 3.33333,
    mask: "url(#path-1-inside-1_44981_9412)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_44981_9412",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 10,
    height: 10,
    rx: 0.833333
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 10,
    height: 10,
    rx: 0.833333,
    stroke: "currentColor",
    strokeWidth: 3.33333,
    mask: "url(#path-2-inside-2_44981_9412)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1668 11.6667H27.5002C27.9604 11.6667 28.3335 12.0398 28.3335 12.5V15.8333",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 28.3333H24.1667C24.6269 28.3333 25 28.7064 25 29.1667V32.5",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 28.3333H12.4998C12.0396 28.3333 11.6665 27.9602 11.6665 27.5V24.1667",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 11.6667H14.1668C13.7066 11.6667 13.3335 11.2936 13.3335 10.8333V7.49999",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.6668,
    y1: 5,
    x2: 11.6668,
    y2: 8.33333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.6668,
    y1: 31.6667,
    x2: 11.6668,
    y2: 35,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.8333,
    y1: 5,
    x2: 15.8333,
    y2: 8.33333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15.8333,
    y1: 31.6667,
    x2: 15.8333,
    y2: 35,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 19.9998,
    y1: 5,
    x2: 19.9998,
    y2: 8.33333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 19.9998,
    y1: 31.6667,
    x2: 19.9998,
    y2: 35,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 24.1668,
    y1: 5,
    x2: 24.1668,
    y2: 8.33333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 24.1668,
    y1: 31.6667,
    x2: 24.1668,
    y2: 35,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 28.3333,
    y1: 5,
    x2: 28.3333,
    y2: 8.33333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 28.3333,
    y1: 31.6667,
    x2: 28.3333,
    y2: 35,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 11.6667,
    x2: 31.6667,
    y2: 11.6667,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 8.3335,
    y1: 11.6667,
    x2: 5.00016,
    y2: 11.6667,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 15.8333,
    x2: 31.6667,
    y2: 15.8333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 8.3335,
    y1: 15.8333,
    x2: 5.00016,
    y2: 15.8333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 20,
    x2: 31.6667,
    y2: 20,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 8.3335,
    y1: 20,
    x2: 5.00016,
    y2: 20,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 24.1667,
    x2: 31.6667,
    y2: 24.1667,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 8.3335,
    y1: 24.1667,
    x2: 5.00016,
    y2: 24.1667,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 28.3333,
    x2: 31.6667,
    y2: 28.3333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 8.3335,
    y1: 28.3333,
    x2: 5.00016,
    y2: 28.3333,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAutomation);
export default __webpack_public_path__ + "static/media/Device Automation.e88265be905e7a6fe310efc6ea1e18d6.svg";
export { ForwardRef as ReactComponent };